import { portal, config } from "../config/portalConfig";

const usePortalConfig = () => ({
  portal,
  config,
});

export default usePortalConfig;